import {DashboardRepository} from "./cache/DashboardRepository";
import {DefaultDashboardConfigurationService} from "./DefaultDashboardConfigurationService";

export default function() {
    return angular.module("tfApp.dashboard.oms.services", [])
                  .service(DashboardRepository.id, DashboardRepository)
                  .service(DefaultDashboardConfigurationService.id, DefaultDashboardConfigurationService)

                  .name;
}
